import fetch from '../../utils/fetch.js'
import * as types from '../types'

const state = {
  userInfo: null
}

const mutations = {
  setUserInfo (state, userInfo) {
    state.userInfo = userInfo
  },
  [types.LOGOUT] (state) {
    state.userInfo = null
  }
}

const actions = {
  getUserInfo ({ commit }) {
    return fetch('get', '/my/info')
      .then(res => {
        commit('setUserInfo', res.data)
        return res
      })
  }
}

const getters = {
  roles: state => {
    return state.userInfo ? state.userInfo.roles : []
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js